import React from "react";
import { Header, Segment } from "semantic-ui-react";
import PermissionTable from "../permission-table";

const actions = [
  "Create_draft_record",
  "Read_draft_record",
  "Edit_draft_record",
  "Upload_draft_files",
  "Read_draft_files",
  "Delete_draft_files",
  "Delete_draft_record",
  "Accept_publication_request",
  "Read_published_record",
];
const roles = ["Record_owner", "Owner", "Curator", "Data_provider"];

const permissions = {
  Record_owner: {
    Create_draft_record: true,
    Read_draft_record: true,
    Edit_draft_record: true,
    Upload_draft_files: true,
    Read_draft_files: true,
    Delete_draft_files: true,
    Delete_draft_record: true,
    Accept_publication_request: false,
    Read_published_record: true,
  },
  Owner: {
    Create_draft_record: true,
    Read_draft_record: true,
    Edit_draft_record: false,
    Upload_draft_files: false,
    Read_draft_files: true,
    Delete_draft_files: true,
    Delete_draft_record: true,
    Accept_publication_request: true,
    Read_published_record: true,
  },
  Curator: {
    Create_draft_record: true,
    Read_draft_record: true,
    Edit_draft_record: false,
    Upload_draft_files: false,
    Read_draft_files: true,
    Delete_draft_files: true,
    Delete_draft_record: true,
    Accept_publication_request: true,
    Read_published_record: true,
  },
  Data_provider: {
    Create_draft_record: true,
    Read_draft_record: false,
    Edit_draft_record: false,
    Upload_draft_files: false,
    Read_draft_files: false,
    Delete_draft_files: false,
    Delete_draft_record: false,
    Accept_publication_request: false,
    Read_published_record: true,
  },
};

const PermissionsPage = () => {
  return (
    <>
      <Header as="h2">Community permission tabel </Header>
      <PermissionTable
        permissions={permissions}
        actionList={actions}
        roleList={roles}
      />
    </>
  );
};

export default PermissionsPage;
